export default {
    setConnectedAccounts(state, payload) {
        state.connectedGooglePlayAccounts = payload;
    },
    setClientDetails(state, payload) {
        state.authUrl = payload;
    },
    setPackages(state,payload){
        state.packages = payload;
    }
}